import {Component, Inject} from '@angular/core';


import {Group} from 'src/app/models';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-members-delete',
    templateUrl: './groups-delete.component.html'
})
export class DeleteGroupsDialogComponent {
    group: Group;
    dialogTitle: string;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.group = new Group();
        this.group.name = this.data.dataKey;
        this.dialogTitle = this.data.dialogTitle;
    }

}
